{
 "id": "sanctuary-temple",
 "light": 0.85,
 "_note": "M10 Kanemori Sanctuary strip (x256-335), the ridge wall, the restored sanctuary (main hall, pagoda, kura, bell tower), the mountain road and the Kanemori checkpoint. Hand-placed temple buildings plus f* forest/mountain filler rectangles (face 0) generated to cover every other solid tile. Painters: client/src/hd-sanctuary.ts (kinds, roofs) and hd-sanctuary-place.ts (ground, edges, props, lights).",
 "rect": {
  "x": 256,
  "y": 44,
  "w": 80,
  "h": 52
 },
 "lamps": [],
 "buildings": [
  { "id": "cp-booth", "x": 264, "y": 76, "w": 10, "h": 4, "face": 3, "kind": "sanctBooth", "roof": "sanctCorpRoof" },
  { "id": "cp-wall", "x": 264, "y": 90, "w": 10, "h": 2, "face": 0, "kind": "sanctFill", "roof": "sanctCorpWall" },
  { "id": "hall", "x": 296, "y": 50, "w": 20, "h": 16, "face": 4, "kind": "sanctHall", "roof": "sanctHallRoof" },
  { "id": "pagoda", "x": 284, "y": 46, "w": 8, "h": 12, "face": 3, "kind": "sanctPagoda", "roof": "sanctPagodaRoof" },
  { "id": "kura", "x": 292, "y": 58, "w": 4, "h": 8, "face": 3, "kind": "sanctKura", "roof": "sanctSmallRoof" },
  { "id": "bell", "x": 316, "y": 58, "w": 4, "h": 8, "face": 3, "kind": "sanctBell", "roof": "sanctSmallRoof" },
  { "id": "court-wall", "x": 284, "y": 80, "w": 44, "h": 2, "face": 0, "kind": "sanctFill", "roof": "sanctTempleWall" },
  { "id": "ridge-wall-w", "x": 292, "y": 44, "w": 30, "h": 2, "face": 0, "kind": "sanctFill", "roof": "sanctRidgeWall" },
  { "id": "ridge-wall-e", "x": 325, "y": 44, "w": 11, "h": 2, "face": 0, "kind": "sanctFill", "roof": "sanctRidgeWall" },
  { "id": "hokora", "x": 269, "y": 47, "w": 3, "h": 2, "face": 0, "kind": "sanctFill", "roof": "countryBase" },
  { "id": "pickers-rest", "x": 260, "y": 93, "w": 3, "h": 2, "face": 0, "kind": "sanctFill", "roof": "countryBase" },
  { "id": "fall-rock", "x": 285, "y": 82, "w": 3, "h": 2, "face": 0, "kind": "sanctFill", "roof": "countryBase" },
  { "id": "f17", "x": 258, "y": 44, "w": 34, "h": 2, "face": 0, "kind": "sanctFill", "roof": "sanctCedar" },
  { "id": "f19", "x": 334, "y": 46, "w": 2, "h": 50, "face": 0, "kind": "sanctFill", "roof": "sanctCedar" },
  { "id": "wall-t1", "x": 256, "y": 44, "w": 2, "h": 36, "face": 0, "kind": "sanctFill", "roof": "sanctWall" },
  { "id": "gate-n", "x": 256, "y": 80, "w": 2, "h": 4, "face": 2, "kind": "sanctGateLodge", "roof": "sanctGateRoof" },
  { "id": "gate-s", "x": 256, "y": 87, "w": 2, "h": 3, "face": 0, "kind": "sanctFill", "roof": "sanctGateRoof" },
  { "id": "wall-t2", "x": 256, "y": 90, "w": 2, "h": 6, "face": 0, "kind": "sanctFill", "roof": "sanctWall" }
 ]
}
